if (!customElements.get('distributor-popup')) {
  customElements.define(
    'distributor-popup',
    class DistributorPopup extends ModalElement {
      constructor() {
        super();

        this.init();
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get cartOnly() {
        return this.getAttribute('data-trigger') === 'cart_only';
      }

      get delay() {
        return 1;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }

      get cookieName() {
        return 'concept:distributor-popup';
      }

      get debugActive() {
        return window.DistributorTheme && window.DistributorTheme.isDebugEnabled();
      }

      init() {
        // Keep the popup available to the production cart guard.
        this.distributor = window.DistributorTheme && window.DistributorTheme.getDistributor(this.testMode);
        if (!this.distributor) return;

        if (!this.testMode && window.DistributorTheme.isExemptBuyer(this.distributor)) return;

        this.applyContent(this.distributor);

        // Page-load trigger fires only on the visitor's first entry (until the
        // cookie expires). Test mode (theme editor) always shows it so it stays
        // visible while designing. When the section is set to "cart_only", the
        // page-load trigger is skipped entirely (test mode still shows it so it
        // stays visible while designing). The add-to-cart trigger lives in
        // distributor-cart-guard.js and fires regardless of this cookie/setting.
        if (this.cartOnly && !this.testMode) return;

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      applyContent(distributor) {
        var name = distributor.company_name || '';
        var url = distributor.distributor_url || '';
        var countryName = distributor.country_name || distributor.country || '';
        var linkHtml = '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + name + '</a>';

        this.querySelectorAll('[data-distributor-field="heading"]').forEach((el) => {
          el.innerHTML = el.innerHTML.replace('[DISTRIBUTOR_NAME]', name).replace('[DISTRIBUTOR_COUNTRY]', countryName);
        });

        this.querySelectorAll('[data-distributor-field="text"]').forEach((el) => {
          el.innerHTML = el.innerHTML
            .replace('[DISTRIBUTOR_LINK]', linkHtml)
            .replace('[DISTRIBUTOR_NAME]', name)
            .replace('[DISTRIBUTOR_COUNTRY]', countryName);
        });

        var linkButton = this.querySelector('[data-distributor-field="link"]');
        if (linkButton && url) {
          linkButton.href = url;
          linkButton.hidden = false;
        }
      }

      forceShow(distributor) {
        this.distributor = distributor;
        this.applyContent(distributor);
        this.show();
      }

      load(delay) {
        if (Shopify.designMode && !this.debugActive) return;

        setTimeout(() => this.show(), delay * 1000);
      }

      afterHide() {
        super.afterHide();

        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
